import { Component } from '@angular/core';

@Component({
    selector: 'app-powders-data',
    templateUrl: './powders-data.component.html',
    styleUrl: './powders-data.component.css',
    standalone: false
})
export class PowdersDataComponent {

}
